// 环境与基础 URL 配置（支持正式与测试环境，并可通过环境变量自动切换）

// 规范化环境值：支持 NODE_ENV 或 VUE_APP_ENV，多种别名映射
function normalizeEnv(env) {
  const e = String(env || '').toLowerCase()
  if (e.startsWith('prod')) return 'production'
  if (e.startsWith('test') || e === 'qa' || e === 'staging') return 'test'
  return 'development'
}

// 各环境的基础 URL 配置
// 优先使用更具体的环境变量，其次回退到通用变量，最终回退到 '/api'
const API_CONFIG = {
  development: {
    baseURL: process.env.VUE_APP_DEV_BASE_API || process.env.VUE_APP_BASE_API || '/api'
  },
  test: {
    baseURL: process.env.VUE_APP_TEST_BASE_API || '/api'
  },
  production: {
    baseURL: process.env.VUE_APP_PROD_BASE_API || process.env.VUE_APP_BASE_API || '/api'
  }
}

const API_ENV = normalizeEnv(process.env.VUE_APP_ENV || process.env.NODE_ENV)
const apiBaseURL = (API_CONFIG[API_ENV] && API_CONFIG[API_ENV].baseURL) || '/api'
const apiPrefix = process.env.VUE_APP_API_PREFIX || '/big-screen-data-api'

export { API_ENV, API_CONFIG, apiBaseURL, apiPrefix }